import { createStitches } from '@stitches/react'

const $color = '#0e1664 !important'

export const { styled, css } = createStitches({
  media: {
    small: '(min-width: 992px)',
    middle: '(min-width: 1200px)',
    large: '(min-width: 1400px)',
    mobile: '(max-width: 991px)',
  },
})

const MobileMenu = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  marginRight: '5px',
})

const MenuContainer = styled('section', {
  padding: '0px 24px 10px 24px',
  width: '100%',
  gap: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative',
  '& > nav > .navbar-collapse': {
    paddingRight: '0!important',
  },
  '& > *': {
    flex: '1 1 0',
    width: '100%',
  },
  '&:first-child': {
    height: 'auto',
    padding: '0 1rem',
    justifyContent: 'flex-end',
  },
  div: {
    gap: 15,
    display: 'flex',
  },
  '@media (min-width: 992px) and (max-width: 1400px)': {
    gap: 10,
    height: 'auto',
  },
})

const HeaderMenuDropdown = styled('a', {
  fontSize: '18px',
  '@mobile': {
    fontSize: '15px',
  },
  fontWeight: 600,
  color: $color,
  textDecoration: 'none',
  display: 'flex',
  justifyContent: 'flex-start',
  marginLeft: '2.5px 0 2.5px 0',
  width: '100%',
  alignItems: 'center',
  height: '40px',
  border: '1px solid #CFD7E4',
  padding: '10px',
  variants: {
    color: {
      default: {},
    },
  },

  '&:hover': {
    backgroundColor: '#CFD7E4',
    color: '#002469 !important',
  },
})
const TopNavigationWrapper = styled('div', {
  maxHeight: 35,
  width: '100%',
  paddingRight: '15px',
  backgroundColor: '$topNavigationBackgroundColor',
  paddingBottom: 55,
  marginTop: -7,
})

const headerLogoutButton = document.getElementById('headerLogoutButton')

if (headerLogoutButton) {
  const parentElement = headerLogoutButton.parentElement
  if (parentElement) {
    parentElement.style.marginBottom = '18px'
  }
}
const ContextMenu = styled('div', {
  top: 34,
  width: 'auto',
  display: 'none',
  flexDirection: 'column',
  // fontFamily: 'ford-antenna-regular-xcnd', fetching from _fonts.sass
  position: 'absolute',
  alignSelf: 'center',
  zIndex: 999,
  gap: 10,
  backgroundColor: '#fff',
  padding: 14,
  borderRadius: 4,
  border: '1px solid #808080',
  transformStyle: 'preserve-3d',

  '&.web': {
    width: 700,
  },

  '&::before': {
    content: '',
    width: '100%',
    height: 12,
    backgroundColor: 'transparent',
    top: -12,
    left: 0,
    position: 'absolute',
  },
  '&::after': {
    content: '',
    width: 10,
    height: 10,
    alignSelf: 'left',
    display: 'flex',
    backgroundColor: 'white',
    top: -6,
    borderWidth: 1,
    borderTopStyle: 'solid',
    borderLeftStyle: 'solid',
    borderColor: '#808080',
    position: 'absolute',
    zIndex: -1,
    transform: ' rotate(45deg)',
  },
})
const Group = styled('div', {
  backgroundColor: '$primary-color!important',
  alignItems: 'center',
  display: 'flex',
  gap: 40,
  flexDirection: 'row',
  '&:last-child': {
    width: '40%',
    gap: 10,
    '& > form': {
      '& > div': { margin: '0!important' },
      '& > label': { position: 'absolute', right: 0 },
      width: '100%',
      position: 'relative',
      '@media (max-width: 1500px)': {
        paddingLeft: 50,
      },
      '@media (max-width: 1400px)': {
        paddingLeft: 180,
      },
      '@media (max-width: 1200px)': {
        paddingLeft: 200,
      },
      '@media (max-width: 1100px)': {
        paddingLeft: 250,
      },
    },
    '& a': {
      textDecoration: 'none',
      '& > span': {
        color: $color,
      },
    },
  },
})

const Menu = styled('nav', {
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
  flexWrap: 'wrap',

  '@media (max-width: 1400px)': {
    gap: 30,
    marginleft: 0,
    justifyContent: 'flex-start',
  },

  '@media (max-width: 768px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 15,
  },
})

const MobileMenuIcon = styled('div', {
  display: 'flex',
  padding: 4,
  border: '1px solid #252525',
  borderRadius: 5,
  cursor: 'pointer',
  width: 40,
  height: 40,
  alignItems: 'center',
  justifyContent: 'center',
})
const MyAccount = styled('div', {
  '& > nav > div': {
    padding: '0!important',
    marginBottom: 0,
  },
})

const MyAccountContainer = styled('div', {
  marginBottom: 10,
  display: 'flex',
  gap: 10,
  flexDirection: 'column',
  '& > :last-child > a': {
    color: '#fff0',
    '& > a': {
      textDecoration: 'none',
    },
  },
})

const HeaderWelcomeContainerMob = styled('div', {
  display: 'none',
  gap: 4,
  alignItems: 'baseline',
  lineHeight: 3,
  '@media (max-width: 767px)': {
    display: 'flex',
    marginLeft: '11px',
  },
})
const Label = styled('a', {
  fontSize: '18px',
  '@mobile': {
    fontSize: '15px',
  },
  fontWeight: 600,
  color: $color,
  position: 'relative',
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  '&:hover > :last-child': {
    display: 'flex',
  },

  '&.menu-right-edge > :last-child': {
    right: 0,
    left: 'auto',
    alignSelf: 'flex-end',
    maxWidth: 'min(700px, calc(100vw - 32px))',
  },
  '&.menu-right-edge > :last-child.web': {
    width: 'min(700px, calc(100vw - 32px))',
  },
  '&.menu-right-edge > :last-child::after': {
    left: 'auto',
    right: 24,
  },

  '@media (max-width: 1400px)': {
    '&.menu-right-edge > :last-child': {
      right: 'auto',
      left: 0,
      alignSelf: 'center',
      maxWidth: 700,
    },
    '&.menu-right-edge > :last-child.web': {
      width: 700,
    },
    '&.menu-right-edge > :last-child::after': {
      right: 'auto',
      left: 24,
    },
  },

  '@media (max-width: 900px)': {
    '&.menu-right-edge > :last-child': {
      maxWidth: '100%',
    },
  },
})

const LabelChevron = styled('div', {
  color: $color,
  display: 'flex',
  gap: 10,
  alignItems: 'center',
})

const ServiceSuport = styled('a', {
  fontSize: '18px',
  '@mobile': {
    fontSize: '15px',
  },
  fontWeight: 600,
  color: $color,
  textDecoration: 'none',
  variants: {
    color: {
      default: {},
    },
  },

  '&:hover': {
    backgroundColor: '#002469',
    color: '#fff !important',
  },
})

export {
  MobileMenu,
  MenuContainer,
  TopNavigationWrapper,
  HeaderMenuDropdown,
  ContextMenu,
  Group,
  Label,
  LabelChevron,
  Menu,
  MobileMenuIcon,
  MyAccount,
  MyAccountContainer,
  HeaderWelcomeContainerMob,
  ServiceSuport,
}
